import { Dispatch, SetStateAction } from "react";
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogTitle,
} from "./alert-dialog";
import { Button } from "./button";

type Props = {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	onConfirmLeave: () => void;
};

export const LeaveDialog = ({ open, setOpen, onConfirmLeave }: Props) => {
	return (
		<AlertDialog open={open} onOpenChange={setOpen}>
			<AlertDialogContent className="gap-0 p-10">
				<AlertDialogTitle className="mb-2 text-base font-semibold">
					Are you sure you want to leave the page?
				</AlertDialogTitle>
				<AlertDialogDescription className="mb-5">
					You have unsaved changes. If you leave the page, these changes will be
					lost.
				</AlertDialogDescription>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={() => setOpen(false)} className="shadow">
						Stay on this page
					</AlertDialogCancel>
					<Button type="button" onClick={onConfirmLeave}>
						Yes, leave this page
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
